import { Fragment } from "react";
import "./EthereumBlockchain.css";
import { Ethereum } from "../../staticdata";
import ethereumdevbanner from "../../assets/images/services/blockchain/ethereumdevelopment.jpg";


const EthereumBlockchain = () => {
  return (
    <Fragment>
      <section className="ethereum-style">
        <div className="ethereum-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="ethereum-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Ethereum Blockchain Development 
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  we deliver custom solutions to help businesses design and
                  build a dynamic, secure, scalable, and innovative Ethereum
                  ecosystem, which makes your goals a reality in the real world.
                  Our expert team helps your business with Ethereum Blockchain
                  development that enhances workflow, user interaction, and
                  roadmap for successful technology innovation and customer
                  support.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={ethereumdevbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="ethereum-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Ethereum Blockchain Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {Ethereum.map((services, index) => (
                <div className="col-lg-4 col-md-6" key={services.id} data-aos="zoom-in">
                  <div className="ethereum-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default EthereumBlockchain;
